import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide8 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={7} total={total} onActive={onActive} label="Leverage Curve">
      <div className="absolute inset-0 radial-gold opacity-40" />

      <div className="relative z-10 w-full max-w-6xl px-6 md:px-12">
        <div className="mb-10">
          <div className="overline mb-4">{t.overline}</div>
          <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
            {t.heading}
          </h2>
          <p className="mt-4 font-mono text-sm tracking-wider text-[var(--ph-accent)]/80">
            {t.sub}
          </p>
        </div>

        <div className="glass-strong rounded-2xl overflow-hidden">
          <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-white/8 font-mono text-[10px] tracking-widest text-neutral-500">
            <div className="col-span-4">RANGE</div>
            <div className="col-span-3">PHASE</div>
            <div className="col-span-5">SIGNAL</div>
          </div>
          {t.brackets.map((b, i) => {
            const intensity = (i + 1) / t.brackets.length;
            return (
              <div
                key={i}
                className="grid grid-cols-12 gap-4 px-6 py-5 border-b border-white/5 last:border-b-0 items-center hover:bg-white/[0.02] transition-colors"
                data-testid={`s8-bracket-${i}`}
              >
                <div className="col-span-4">
                  <span className="font-display text-xl md:text-2xl">{b.range}</span>
                </div>
                <div className="col-span-3">
                  <span
                    className="inline-block px-3 py-1 rounded-full text-[11px] font-mono tracking-widest"
                    style={{
                      background: `rgba(212, 175, 55, ${0.08 + intensity * 0.18})`,
                      color: i >= 3 ? "#000" : "var(--ph-accent)",
                      backgroundColor:
                        i >= 3
                          ? `rgba(212, 175, 55, ${0.6 + intensity * 0.4})`
                          : `rgba(212, 175, 55, ${0.08 + intensity * 0.1})`,
                    }}
                  >
                    {b.phase.toUpperCase()}
                  </span>
                </div>
                <div className="col-span-5">
                  <span className="text-sm text-neutral-300">{b.note}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </SlideShell>
  );
};


